import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import BottomSheet from '@/components/BottomSheet';
import BottomSheetContent, {
  IBottomSheetContentProps,
} from './BottomSheetContent';

type TUseOpenBottomSheetProps = Pick<IBottomSheetContentProps, 'onClose'>;

const useOpenBottomSheet = ({ onClose }: TUseOpenBottomSheetProps) => {
  const [isScrolled, setIsScrolled] = useState<boolean>(false);
  const pathname = usePathname();

  const handleClose = () => {
    BottomSheet.close();
    onClose?.();
    setIsScrolled(false);
  };

  useEffect(() => {
    window.addEventListener('popstate', handleClose);

    return () => {
      window.removeEventListener('popstate', handleClose);
    };
  }, [pathname]);

  const handleOpen = () => {
    BottomSheet.open({
      classNames: {
        overlay: '!z-[99997]',
        sheet: '!pb-0 h-[calc(100%-252px)] md:h-[calc(100%-192px)]',
      },
      sheetProps: { onScroll: () => !isScrolled && setIsScrolled(true) },
      isDraggable: false,
      closeAction: handleClose,
      children: <BottomSheetContent onClose={handleClose} />,
    });
  };

  useEffect(() => {
    if (isScrolled) {
      BottomSheet.update({
        classNames: {
          sheet:
            '!pb-0 transition-all duration-500 h-[calc(100%-80px)] md:h-[calc(100%-16px)]',
        },
      });
    }
  }, [isScrolled]);

  return handleOpen;
};

export default useOpenBottomSheet;
